/**
 * Builds POST body from in-memory preferences answers.
 *
 * Belongs here: submit payload shape.
 * Does not belong here: API transport.
 */
import type { SubmitPreferencesApiRequest, PreferencesAnswersMap } from '../preferences/setup/types'
import type { SubmitQuestionInput } from '../shared/types/questionnaire.types'

function buildQuestionInputs(answers: PreferencesAnswersMap): SubmitQuestionInput[] {
  return Object.entries(answers).map(([questionId, value]) => {
    const input: SubmitQuestionInput = { questionId }
    if (typeof value === 'number') {
      input.inputValueDouble = value
    } else if (Array.isArray(value)) {
      input.optionId = value
    } else {
      input.optionId = (value ?? '') !== '' ? [String(value)] : undefined
    }
    return input
  })
}

export function buildSubmitPreferencesPayload(
  questionnaireId: string,
  answers: PreferencesAnswersMap
): SubmitPreferencesApiRequest {
  return { questionnaireId: questionnaireId, questionInputs: buildQuestionInputs(answers) }
}
